<div class="container" *ngLet="langChange$ | async">
  <div class="text-block" *ngLet="authenticatedUser$ | async">
    <div class="left-column">
      <h2 class="h1">{{ 'MAIN.DEVELOPERS_ACCOUNT' | translate }}</h2>
      <div class="body-1">
        {{ 'DEVELOPER.DEVELOPER_MAIN_TEXT' | translate }}
      </div>
      <ng-container *ngLet="currentApiKey$ | async as currentApiKey">
        <ng-container *ngLet="loadingApiKey$ | async as loadApiKey">
          <div *ngIf="loadApiKey" class="loader-container">
            <app-loader></app-loader>
          </div>

          <button (click)="getApiKey()" *ngIf="!currentApiKey && !loadApiKey" class="btn-primary big mt32">
            {{ 'OTHER.GET_API_KEY' | translate }}
          </button>

          <div class="mt20 flex-center" *ngIf="currentApiKey && !loadApiKey">
            <mat-form-field class="key-container" appearance="outline">
              <mat-label>{{ 'OTHER.YOUR_API_KEY' | translate }}:</mat-label>
              <input [type]="hideApiKey ? 'password' : 'text'" matInput disabled [value]="currentApiKey" />
            </mat-form-field>
            <app-hoverable-svg
              [icon]="hideApiKey ? icons.Eye : icons.HideEye"
              [matTooltip]="(hideApiKey ? 'OTHER.SHOW_APIKEY' : 'OTHER.HIDE_APIKEY') | translate"
              (click)="hideApiKey = !hideApiKey"
              class="svg24 dark-gray-color pc-icon"
            ></app-hoverable-svg>
            <app-hoverable-svg
              [icon]="icons.Copy"
              (click)="copyLinks(currentApiKey)"
              [matTooltip]="'OTHER.COPY_APIKEY' | translate"
              class="svg24 dark-gray-color pc-icon"
            >
            </app-hoverable-svg>
            <div class="mobile-block">
              <svg
                [icon]="hideApiKey ? icons.Eye18 : icons.HideEye18"
                [matTooltip]="(hideApiKey ? 'OTHER.SHOW_APIKEY' : 'OTHER.HIDE_APIKEY') | translate"
                (click)="hideApiKey = !hideApiKey"
                class="svg18 primary-color mr8"
              />
              <span (click)="hideApiKey = !hideApiKey" class="mr24 caption-3 primary-color">{{
                (hideApiKey ? 'OTHER.SHOW_APIKEY' : 'OTHER.HIDE_APIKEY') | translate
              }}</span>
              <svg [icon]="icons.Copy18" (click)="copyLinks(currentApiKey)" class="primary-color svg18 mr8" />
              <span (click)="copyLinks(currentApiKey)" class="caption-3 primary-color">{{ 'OTHER.COPY_APIKEY' | translate }}</span>
            </div>
          </div>
        </ng-container>
      </ng-container>
      <a *ngIf="isRuLocale" (click)="goInformationPlacement()" class="link-1 placement-form mt24">
        <svg [icon]="icons.AddPlus" class="svg24 mr12" />
        {{ 'INFORMATION_PLACEMENT_FORM.TITLE' | translate }}
      </a>
    </div>
    <div class="right-column">
      <mat-icon svgIcon="developers"></mat-icon>
    </div>
  </div>

  <div class="card-wrapper">
    <app-card
      *ngFor="let card of cardsInfo"
      [title]="card.title"
      [buttonName]="card.buttonName"
      [icon]="card.icon"
      [text]="card.text"
      [route]="card?.route"
      [click]="card?.buttonClick"
      [mobileText]="card?.mobileText"
    >
    </app-card>
  </div>
</div>
<app-footer></app-footer>
